import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Switch do DS (ORCA-1929). Sem texto de estado ("Ativo/Inativo"): o próprio switch mostra.
 * Sozinho precisa de `label` (vira aria-label). Com conteúdo projetado, vira uma linha de configuração.
 */
@Component({
    selector: 'oa-switch',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <label *ngIf="row; else alone" class="oa-switch-row">
            <span class="oa-switch-row__text">
                <ng-content></ng-content>
                <small *ngIf="hint">{{ hint }}</small>
            </span>
            <ng-container *ngTemplateOutlet="alone"></ng-container>
        </label>
        <ng-template #alone>
            <button type="button" role="switch" class="oa-switch" [class.oa-switch--sm]="size === 'sm'"
                [attr.aria-checked]="checked ? 'true' : 'false'" [attr.aria-label]="label || null"
                [disabled]="disabled" (click)="toggle($event)">
                <span class="oa-switch__knob"></span>
            </button>
        </ng-template>
    `,
})
export class OaSwitchComponent {
    @Input() checked = false;
    @Input() label?: string;
    @Input() hint?: string;
    @Input() size: 'sm' | 'md' = 'md';
    @Input() disabled = false;
    /** Linha com texto (conteúdo projetado) à esquerda */
    @Input() row = false;
    @Output() checkedChange = new EventEmitter<boolean>();

    toggle(event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.checked = !this.checked;
        this.checkedChange.emit(this.checked);
    }
}
